var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _g, _path29, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoctorAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.75 56.25H56.25V67.1875H43.75V56.25Z",
    fill: "url(#paint0_linear_893_6079)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.75 62.5C45.1755 64.0177 47.4443 65.1042 50 65.1042C52.6141 65.1042 54.8318 64.0771 56.25 62.5V82.2922H43.75V62.5Z",
    fill: "url(#paint1_linear_893_6079)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7497 62.5C45.1752 64.0177 47.4439 65.1042 49.9997 65.1042C52.6137 65.1042 54.8314 64.0771 56.2497 62.5C56.8268 62.6276 57.5408 62.8 58.346 63.0078C57.1346 65.4406 53.8601 67.1875 49.9997 67.1875C46.1393 67.1875 42.8648 65.4406 41.6533 63.0078C42.4585 62.8 43.1726 62.6281 43.7497 62.5Z",
    fill: "url(#paint2_linear_893_6079)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8955 68.2286L25.5205 67.1875C25.5205 67.1875 20.3122 72.3958 17.708 82.2917H34.8955V68.2286Z",
    fill: "url(#paint3_linear_893_6079)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6663 61.9805C37.9533 62.8029 28.5992 64.931 25.5205 67.1888L30.7288 82.293H47.9163L41.6663 61.9805Z",
    fill: "url(#paint4_linear_893_6079)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1035 68.2286L74.4785 67.1875C74.4785 67.1875 79.6868 72.3958 82.291 82.2917H65.1035V68.2286Z",
    fill: "url(#paint5_linear_893_6079)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M58.333 61.9805C62.046 62.8029 71.4002 64.931 74.4788 67.1888L69.2705 82.293H52.083L58.333 61.9805Z",
    fill: "url(#paint6_linear_893_6079)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M68.7497 44.1964C68.7497 46.4974 67.1174 48.9583 65.1038 48.9583C63.0903 48.9583 61.458 46.4974 61.458 44.1964C61.458 41.8953 63.0903 40.625 65.1038 40.625C67.1174 40.625 68.7497 41.8953 68.7497 44.1964Z",
    fill: "url(#paint7_linear_893_6079)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0202 44.1964C38.0202 46.4974 36.3879 48.9583 34.3743 48.9583C32.3608 48.9583 30.7285 46.4974 30.7285 44.1964C30.7285 41.8953 32.3608 40.625 34.3743 40.625C36.3879 40.625 38.0202 41.8953 38.0202 44.1964Z",
    fill: "url(#paint8_linear_893_6079)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0205 31.25H36.9788C35.8132 31.5328 34.8955 32.6547 34.8955 33.8542V44.2745C34.8955 53.125 41.6663 59.8958 49.9997 59.8958C58.333 59.8958 65.1038 53.125 65.1038 44.2745V33.8542C65.1038 32.651 64.1908 31.5297 63.0205 31.25Z",
    fill: "url(#paint9_linear_893_6079)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9997 17.709C58.169 17.709 67.1872 24.0569 67.1872 33.8548C67.1601 40.059 65.1038 44.2715 65.1038 44.2715C65.1038 41.1465 63.5413 33.8548 63.5413 33.8548C54.6872 35.9382 36.9788 31.7715 36.9788 31.7715C36.9788 31.7715 34.8955 34.8965 34.8955 44.2715C34.8955 44.2715 31.7705 40.6257 31.7705 34.3757C31.7705 26.5819 35.4163 25.0007 35.4163 25.0007C35.4163 25.0007 36.458 17.709 49.9997 17.709Z",
    fill: "url(#paint10_linear_893_6079)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9905 56.2508C48.8134 56.2508 47.6394 55.8717 46.5728 55.1144C46.4601 55.0343 46.3839 54.9128 46.3608 54.7765C46.3378 54.6403 46.3698 54.5004 46.4498 54.3878C46.5299 54.2752 46.6514 54.1989 46.7877 54.1759C46.9239 54.1528 47.0638 54.1848 47.1764 54.2649C48.9592 55.5321 51.0181 55.5315 52.8259 54.2633C52.8819 54.2238 52.9451 54.1957 53.0119 54.1807C53.0788 54.1656 53.1479 54.1639 53.2154 54.1757C53.2829 54.1874 53.3475 54.2123 53.4053 54.249C53.4632 54.2857 53.5132 54.3335 53.5526 54.3896C53.5919 54.4457 53.6198 54.509 53.6347 54.5758C53.6496 54.6427 53.6511 54.7119 53.6392 54.7794C53.6273 54.8468 53.6021 54.9113 53.5653 54.9691C53.5284 55.0268 53.4805 55.0767 53.4243 55.1159C52.3457 55.8722 51.1665 56.2508 49.9905 56.2508Z",
    fill: "url(#paint11_linear_893_6079)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2285 46.3555C44.0915 46.3555 44.791 45.6559 44.791 44.793C44.791 43.93 44.0915 43.2305 43.2285 43.2305C42.3656 43.2305 41.666 43.93 41.666 44.793C41.666 45.6559 42.3656 46.3555 43.2285 46.3555Z",
    fill: "url(#paint12_linear_893_6079)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7705 46.3555C57.6335 46.3555 58.333 45.6559 58.333 44.793C58.333 43.93 57.6335 43.2305 56.7705 43.2305C55.9076 43.2305 55.208 43.93 55.208 44.793C55.208 45.6559 55.9076 46.3555 56.7705 46.3555Z",
    fill: "url(#paint13_linear_893_6079)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3535 40.6226C46.2563 40.6226 46.161 40.5953 46.0785 40.544C43.1832 38.7414 41.2972 39.9539 40.492 40.4721L40.3826 40.5424C40.266 40.6101 40.1277 40.63 39.9967 40.5978C39.8658 40.5657 39.7523 40.4841 39.6803 40.3701C39.6082 40.2561 39.5831 40.1186 39.6103 39.9865C39.6374 39.8544 39.7147 39.738 39.8259 39.6617L39.929 39.5961C40.8165 39.0247 43.1759 37.5091 46.6295 39.6601C46.7254 39.7201 46.7992 39.8096 46.8397 39.9152C46.8803 40.0208 46.8853 40.1367 46.8541 40.2454C46.8229 40.3541 46.7572 40.4497 46.6669 40.5178C46.5766 40.5858 46.4666 40.6226 46.3535 40.6226Z",
    fill: "url(#paint14_linear_893_6079)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6458 40.6229C53.5327 40.6229 53.4227 40.5861 53.3324 40.5181C53.2421 40.45 53.1764 40.3544 53.1452 40.2457C53.114 40.137 53.1191 40.0211 53.1596 39.9155C53.2001 39.8099 53.2739 39.7204 53.3698 39.6604C56.824 37.5084 59.1828 39.0255 60.0708 39.5964L60.1734 39.662C60.2846 39.7383 60.3619 39.8548 60.389 39.9868C60.4162 40.1189 60.3911 40.2564 60.319 40.3704C60.247 40.4844 60.1336 40.566 60.0026 40.5981C59.8716 40.6303 59.7333 40.6104 59.6167 40.5427L59.5073 40.4729C58.7026 39.9552 56.8156 38.7422 53.9203 40.5448C53.8349 40.5974 53.7401 40.6229 53.6458 40.6229Z",
    fill: "url(#paint15_linear_893_6079)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9976 51.5629H49.995C49.4872 51.5619 48.9971 51.3249 48.5778 50.8775C48.489 50.7757 48.4431 50.6434 48.4499 50.5085C48.4566 50.3736 48.5155 50.2466 48.6141 50.1542C48.7127 50.0618 48.8433 50.0113 48.9783 50.0133C49.1134 50.0154 49.2424 50.0697 49.3382 50.165C49.4903 50.327 49.7278 50.5207 49.9965 50.5212H49.9976C50.2684 50.5212 50.5085 50.327 50.6627 50.1634C50.7097 50.1137 50.7659 50.0736 50.8284 50.0456C50.8908 50.0176 50.9581 50.0022 51.0265 50.0002C51.0949 49.9982 51.163 50.0097 51.2269 50.0341C51.2909 50.0584 51.3494 50.0951 51.3992 50.1421C51.4489 50.189 51.4889 50.2453 51.5169 50.3077C51.5449 50.3702 51.5604 50.4375 51.5624 50.5059C51.5643 50.5743 51.5528 50.6424 51.5285 50.7063C51.5042 50.7702 51.4675 50.8288 51.4205 50.8785C50.9976 51.3264 50.5059 51.5629 49.9976 51.5629Z",
    fill: "url(#paint16_linear_893_6079)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7493 60.418L47.916 82.293L39.5827 74.4805L40.6243 70.3138L36.9785 69.7924L41.1452 61.9799C41.5681 61.2148 42.7728 60.4185 43.7493 60.418Z",
    fill: "url(#paint17_linear_893_6079)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2497 60.418L52.083 82.293L60.4163 74.4805L59.3747 70.3138L63.0205 69.7924L58.8538 61.9799C58.4309 61.2148 57.2262 60.4185 56.2497 60.418Z",
    fill: "url(#paint18_linear_893_6079)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1455 78.6458H38.5413C38.4032 78.6458 38.2707 78.591 38.1731 78.4933C38.0754 78.3956 38.0205 78.2631 38.0205 78.125C38.0205 77.9869 38.0754 77.8544 38.1731 77.7567C38.2707 77.659 38.4032 77.6042 38.5413 77.6042H41.1455C41.72 77.6042 42.1872 77.137 42.1872 76.5625V71.3542C42.1872 68.7693 40.0841 66.6667 37.4997 66.6667C34.9153 66.6667 32.8122 68.7693 32.8122 71.3542V76.5625C32.8122 77.137 33.2794 77.6042 33.8538 77.6042H35.9372C36.0753 77.6042 36.2078 77.659 36.3055 77.7567C36.4031 77.8544 36.458 77.9869 36.458 78.125C36.458 78.2631 36.4031 78.3956 36.3055 78.4933C36.2078 78.591 36.0753 78.6458 35.9372 78.6458H33.8538C32.7049 78.6458 31.7705 77.7115 31.7705 76.5625V71.3542C31.7705 68.1953 34.3408 65.625 37.4997 65.625C40.6585 65.625 43.2288 68.1953 43.2288 71.3542V76.5625C43.2288 77.7115 42.2945 78.6458 41.1455 78.6458Z",
    fill: "url(#paint19_linear_893_6079)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4997 65.625C34.3408 65.625 31.7705 68.1953 31.7705 71.3542H32.8122C32.8122 68.7693 34.9153 66.6667 37.4997 66.6667C40.0841 66.6667 42.1872 68.7693 42.1872 71.3542H43.2288C43.2288 68.1953 40.6585 65.625 37.4997 65.625Z",
    fill: "url(#paint20_linear_893_6079)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9372 77.6055H34.8955V78.6471H35.9372C36.0753 78.6471 36.2078 78.5923 36.3055 78.4946C36.4031 78.3969 36.458 78.2644 36.458 78.1263C36.458 77.9882 36.4031 77.8557 36.3055 77.758C36.2078 77.6603 36.0753 77.6055 35.9372 77.6055Z",
    fill: "url(#paint21_linear_893_6079)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5413 77.6055H39.583V78.6471H38.5413C38.4032 78.6471 38.2707 78.5923 38.1731 78.4946C38.0754 78.3969 38.0205 78.2644 38.0205 78.1263C38.0205 77.9882 38.0754 77.8557 38.1731 77.758C38.2707 77.6603 38.4032 77.6055 38.5413 77.6055Z",
    fill: "url(#paint22_linear_893_6079)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3238 57.3633C57.7904 57.7224 57.2344 58.0467 56.6592 58.3341H57.2909C61.3118 58.3341 64.5826 61.6049 64.5826 65.6258V71.8758C64.5826 72.0139 64.6375 72.1464 64.7352 72.2441C64.8328 72.3417 64.9653 72.3966 65.1035 72.3966C65.2416 72.3966 65.3741 72.3417 65.4717 72.2441C65.5694 72.1464 65.6243 72.0139 65.6243 71.8758V65.6258C65.6243 61.3815 62.4321 57.8747 58.3238 57.3633Z",
    fill: "url(#paint23_linear_893_6079)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7082 57.3848C39.0249 57.8592 36.9785 60.203 36.9785 63.0207V66.1457C36.9785 66.2838 37.0334 66.4163 37.1311 66.514C37.2287 66.6117 37.3612 66.6665 37.4993 66.6665C37.6375 66.6665 37.77 66.6117 37.8676 66.514C37.9653 66.4163 38.0202 66.2838 38.0202 66.1457V63.0207C38.0202 60.4358 40.1233 58.3332 42.7077 58.3332C42.8402 58.3327 42.9674 58.2812 43.0629 58.1895C42.5975 57.9453 42.1453 57.6766 41.7082 57.3848Z",
    fill: "url(#paint24_linear_893_6079)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1042 76.5638C66.5424 76.5638 67.7083 75.3979 67.7083 73.9596C67.7083 72.5214 66.5424 71.3555 65.1042 71.3555C63.6659 71.3555 62.5 72.5214 62.5 73.9596C62.5 75.3979 63.6659 76.5638 65.1042 76.5638Z",
    fill: "url(#paint25_linear_893_6079)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1042 76.5638C66.5424 76.5638 67.7083 75.3979 67.7083 73.9596C67.7083 72.5214 66.5424 71.3555 65.1042 71.3555C63.6659 71.3555 62.5 72.5214 62.5 73.9596C62.5 75.3979 63.6659 76.5638 65.1042 76.5638Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_893_6079",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 62,
    y: 71,
    width: 6,
    height: 6
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1042 76.5638C66.5424 76.5638 67.7083 75.3979 67.7083 73.9596C67.7083 72.5214 66.5424 71.3555 65.1042 71.3555C63.6659 71.3555 62.5 72.5214 62.5 73.9596C62.5 75.3979 63.6659 76.5638 65.1042 76.5638Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_893_6079)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.5 71.3555H67.7083V76.5638H62.5V71.3555Z",
    fill: "url(#paint26_linear_893_6079)"
  }))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1035 77.084C63.3801 77.084 61.9785 75.6824 61.9785 73.959C61.9785 72.2355 63.3801 70.834 65.1035 70.834C66.827 70.834 68.2285 72.2355 68.2285 73.959C68.2285 75.6824 66.827 77.084 65.1035 77.084ZM65.1035 71.8757C63.9546 71.8757 63.0202 72.81 63.0202 73.959C63.0202 75.1079 63.9546 76.0423 65.1035 76.0423C66.2525 76.0423 67.1868 75.1079 67.1868 73.959C67.1868 72.81 66.2525 71.8757 65.1035 71.8757Z",
    fill: "url(#paint27_linear_893_6079)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_893_6079",
    x1: 50,
    y1: 65.538,
    x2: 50,
    y2: 60.0693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6CFBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDAD99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_893_6079",
    x1: 49.5594,
    y1: 55.8745,
    x2: 49.4234,
    y2: 50.7724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCF97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAC6A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_893_6079",
    x1: 51.1059,
    y1: 44.387,
    x2: 50.5851,
    y2: 53.1542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCF97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAC6A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_893_6079",
    x1: 24.8648,
    y1: 96.1057,
    x2: 26.6455,
    y2: 78.9922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4E5E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_893_6079",
    x1: 34.6851,
    y1: 92.2279,
    x2: 33.0481,
    y2: 106.307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4E5E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_893_6079",
    x1: 75.1348,
    y1: 96.1057,
    x2: 73.354,
    y2: 78.9922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4E5E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_893_6079",
    x1: 65.3143,
    y1: 92.2279,
    x2: 66.9512,
    y2: 106.307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4E5E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_893_6079",
    x1: 65.1038,
    y1: 28.9932,
    x2: 65.1038,
    y2: 54.3443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6CFBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDAD99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_893_6079",
    x1: 34.3743,
    y1: 28.9932,
    x2: 34.3743,
    y2: 54.3443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6CFBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDAD99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_893_6079",
    x1: 52.5294,
    y1: 26.651,
    x2: 53.9617,
    y2: 19.2292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6CFBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDAD99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_893_6079",
    x1: 49.4788,
    y1: 7.68294,
    x2: 49.4788,
    y2: 51.0158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#957E7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#373638"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_893_6079",
    x1: 50.6306,
    y1: 45.2295,
    x2: 50.3701,
    y2: 49.1357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6CFBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDAD99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_893_6079",
    x1: 43.1014,
    y1: 61.7206,
    x2: 43.1665,
    y2: 53.0622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414042"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_893_6079",
    x1: 56.6429,
    y1: 61.7971,
    x2: 56.708,
    y2: 53.1383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414042"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_893_6079",
    x1: 43.0201,
    y1: 67.8836,
    x2: 43.1071,
    y2: 56.3388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414042"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_893_6079",
    x1: 56.5604,
    y1: 67.986,
    x2: 56.6474,
    y2: 56.4406,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414042"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_893_6079",
    x1: 38.0033,
    y1: 53.1426,
    x2: 42.1377,
    y2: 52.2962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6CFBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDAD99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_893_6079",
    x1: 47.8603,
    y1: 99.2539,
    x2: 46.8296,
    y2: 94.5581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4E5E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_893_6079",
    x1: 52.1393,
    y1: 99.2539,
    x2: 53.17,
    y2: 94.5581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4E5E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_893_6079",
    x1: 38.2669,
    y1: 82.7771,
    x2: 38.1492,
    y2: 81.412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAAEB1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_893_6079",
    x1: 35.7445,
    y1: 57.1312,
    x2: 35.8747,
    y2: 58.1729,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414042"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_893_6079",
    x1: 35.7304,
    y1: 78.9956,
    x2: 35.7205,
    y2: 78.8799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414042"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_893_6079",
    x1: 38.7481,
    y1: 78.9956,
    x2: 38.758,
    y2: 78.8799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414042"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_893_6079",
    x1: 60.1868,
    y1: 54.0768,
    x2: 60.317,
    y2: 55.1185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414042"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_893_6079",
    x1: 39.3327,
    y1: 56.6827,
    x2: 39.4629,
    y2: 57.7243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414042"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_893_6079",
    x1: 70.4016,
    y1: 75.8393,
    x2: 71.663,
    y2: 76.2867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C6F73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56585B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_893_6079",
    x1: 54.9214,
    y1: 72.6055,
    x2: 59.0016,
    y2: 73.1482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C6F73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56585B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_893_6079",
    x1: 54.9207,
    y1: 72.6048,
    x2: 59.0009,
    y2: 73.1475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAAEB1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoctorAvatar);
export default __webpack_public_path__ + "static/media/doctor-avatar.c33480d27f9459977c04c4f04278f143.svg";
export { ForwardRef as ReactComponent };